var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('div',{staticClass:"input-field col s12"},[_c('input',{attrs:{"searchTerm":_vm.searchTerm,"placeholder":_vm.placeholder,"id":"search_box","type":"text","dir":"auto"},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }